var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm._m(0);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "product-cases area"
  }, [_c("header", {
    staticClass: "product-cases__title"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("CASES")]), _c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("客户案例")])]), _c("main", {
    staticClass: "product-cases__main clearfix"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/service/institutional-trading/case1.png"),
      alt: ""
    }
  }), _c("p", {
    staticClass: "content"
  }, [_vm._v(" “华彩人生巅峰时代”是同花顺为其大C客户打造的交易服务平台，满足大C客户对交易系统稳定高速、交易功能个性化支持的需求，提供丰富的交易执行功能如篮子交易、策略条件交易等。 ")])])]);
}];
render._withStripped = true;
export { render, staticRenderFns };